// First-run placeholder shown when /setup/status reports initialized:false.
// The setup wizard lives only in the admin app — link to it as text.
import { useTranslation } from "react-i18next";
import { Radio } from "lucide-react";
import { env } from "../env.js";

export function NotConfiguredPage() {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <div className="surface w-full max-w-md p-8 text-center">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-primary to-[hsl(var(--glow))] text-primary-foreground shadow-glow">
          <Radio className="h-6 w-6" />
        </div>
        <h1 className="font-display text-xl font-semibold text-foreground">
          {t("notConfigured.title", { site: env.siteName })}
        </h1>
        <p className="mt-2 text-sm text-muted-foreground">{t("notConfigured.hint1")}</p>
        <p className="mt-4 text-xs text-muted-foreground/70">{t("notConfigured.hint2")}</p>
      </div>
    </div>
  );
}
